import { useSyncExternalStore } from "react";
import {
	getThemeModeSnapshot,
	type ResolvedThemeMode,
	setThemeMode,
	subscribeThemeMode,
	type ThemeMode,
} from "@/lib/theme-mode";

interface UseThemeMode {
	/** The stored choice: light, dark or system. */
	mode: ThemeMode;
	/** The mode on screen. "system" resolves to light or dark. */
	resolved: ResolvedThemeMode;
	setMode: (mode: ThemeMode) => void;
}

export function useThemeMode(): UseThemeMode {
	const { mode, resolved } = useSyncExternalStore(
		subscribeThemeMode,
		getThemeModeSnapshot,
		getThemeModeSnapshot,
	);
	return { mode, resolved, setMode: setThemeMode };
}
